import { Component} from '@angular/core';

@Component({
    selector: 'processes-type-main',
    templateUrl: './processes-type-main.tmpl.html'
})

export class ProcessesTypeMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  